import { Link } from "react-router-dom";

export const Doubt = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-brand-800 via-brand-700 to-sea-700 py-16 sm:py-20">
      <div className="pointer-events-none absolute -top-16 left-1/4 h-56 w-56 rounded-full bg-white/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-16 right-1/4 h-56 w-56 rounded-full bg-white/10 blur-3xl" />
      <div className="relative mx-auto flex max-w-5xl flex-col items-center justify-between gap-8 px-4 text-center sm:px-6 md:flex-row md:text-left">
        <h2 className="font-display text-3xl font-semibold text-white sm:text-4xl">
          Still Have a Doubt?
        </h2>
        <Link
          to="/contact"
          className="shrink-0 rounded-full bg-white px-8 py-4 text-sm font-bold tracking-widest text-brand-800 shadow-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
        >
          GET STARTED TODAY
        </Link>
      </div>
    </section>
  );
};
